import { render } from "./TheFooter.vue?vue&type=template&id=9e9d0e58&scoped=true"
const script = {}

import "./TheFooter.vue?vue&type=style&index=0&id=9e9d0e58&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-9e9d0e58"

export default script